import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const FaqsSection = () => {
  const form = useRef();
  const [isSending, setIsSending] = useState(false);
  const [status, setStatus] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'How to get free immigration?',
      answer:
        'Sed rhoncus facilisis purus, at accumsan purus sagittis vitae. Nullam ac elit at eros imperdiet. Pellentesque sit.',
    },
    {
      question: 'Which country is good for residents?',
      answer:
        'Sed rhoncus facilisis purus, at accumsan purus sagittis vitae. Nullam ac elit at eros imperdiet. Pellentesque sit.',
    },
    {
      question: 'Canada study visa requirements?',
      answer:
        'Sed rhoncus facilisis purus, at accumsan purus sagittis vitae. Nullam ac elit at eros imperdiet. Pellentesque sit.',
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);
    setStatus(null);

    emailjs
      .sendForm(
        'service_d6ainxm',
        'template_0vplqhz',
        form.current,
        'hoB1AWZoweGe6WGiO'
      )
      .then(() => {
        setStatus('success');
        form.current.reset();
      })
      .catch(() => {
        setStatus('error');
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <section className="faqs-section style-two">
      <div className="auto-container">
        <div className="row">
          {/* SSS - Sol Kısım */}
          <div className="faq-column col-lg-6 col-md-12 col-sm-12 order-2">
            <div className="inner-column">
              <div className="sec-title">
                <span className="sub-title">SSS</span>
                <h2>Sıkça Sorulan Sorular</h2>
                <div className="text">
                  Sed rhoncus facilisis purus, at accumsan purus sagittis vitae.
                  Nullam ac elit at eros imperdiet. Pellentesque sit placerat neque.
                </div>
              </div>

              <ul className="accordion-box wow fadeInRight">
                {faqs.map((faq, index) => {
                  const isActive = activeIndex === index;
                  return (
                    <li
                      key={index}
                      className={`accordion block ${isActive ? 'active-block' : ''}`}
                    >
                      <div
                        className={`acc-btn ${isActive ? 'active' : ''}`}
                        onClick={() => toggleAccordion(index)}
                      >
                        {faq.question}
                        <div className="icon fa fa-angle-right"></div>
                      </div>
                      <div
                        className={`acc-content ${isActive ? 'current' : ''}`}
                        style={{ display: isActive ? 'block' : 'none' }}
                      >
                        <div className="content">
                          <div className="text">{faq.answer}</div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {/* Form - Sağ Kısım */}
          <div className="form-column col-lg-6 col-md-12 col-sm-12">
            <div
              className="form-bg"
              style={{ backgroundImage: 'url(/assets/images/background/3.jpg)' }}
            ></div>
            <div className="inner-column">
              <div className="sec-title light">
                <span className="sub-title">Bize Ulaşın</span>
                <h2>Mesaj Gönder</h2>
              </div>
              <div className="contact-form wow fadeInLeft">
                <form ref={form} onSubmit={sendEmail}>
                  <div className="row">
                    <div className="form-group col-lg-6 col-md-6 col-sm-12">
                      <input
                        type="text"
                        name="fname"
                        placeholder="Adınız"
                        required
                      />
                    </div>
                    <div className="form-group col-lg-6 col-md-6 col-sm-12">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email Adresiniz"
                        required
                      />
                    </div>
                    <div className="form-group col-lg-12">
                      <input
                        type="text"
                        name="title"
                        placeholder="Konu Başlığı"
                        required
                      />
                    </div>
                    <div className="form-group col-lg-12">
                      <textarea
                        name="message"
                        placeholder="Mesajınızı Yazın"
                        required
                      ></textarea>
                    </div>
                    <div className="form-group col-lg-12">
                      <button
                        type="submit"
                        className={`theme-btn btn-style-two ${status === 'success' ? 'sent' : ''}`}
                        disabled={isSending}
                      >
                        <span className="btn-title">
                          {isSending
                            ? 'Gönderiliyor...'
                            : status === 'success'
                            ? 'Mesajınız Gönderildi'
                            : 'Mesaj Gönder'}
                        </span>
                      </button>

                      {/* Durum Mesajı */}
                      {status === 'success' && (
                        <p style={{ color: 'green', marginTop: '10px' }}>
                        </p>
                      )}
                      {status === 'error' && (
                        <p style={{ color: 'red', marginTop: '10px' }}>
                          Gönderim sırasında bir hata oluştu.
                        </p>
                      )}
                    </div>
                  </div>
                </form>
              </div>
              {/* End Contact Form */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqsSection;